module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }],
    staticClass: "mt-2"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, _vm._l((_vm.tableData), function(modelo, i) {
    return _c('el-tab-pane', {
      key: i,
      attrs: {
        "label": i.toString(),
        "name": modelo.id.toString()
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('i', {
      staticClass: "fa fa-list-ol"
    }), _vm._v(" " + _vm._s(modelo.id) + " (" + _vm._s(modelo.nome) + ")\n\t\t\t")]), _vm._v(" "), _c('Conteudo', {
      attrs: {
        "modelo": modelo
      }
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27285489"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/configuracao/modelo/index.vue
// module id = 1434
// module chunks = 45